// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3-FYL","info":"Note_info__3kd8z","note":"Note_note__11q6H","actions":"Note_actions__2tyy2"};